import { webinar } from "./module";

const $sk: any = (window as any).$sk;

$sk.webinar = webinar;
